import type {PreviewCtaComponentProps} from '@cohort/merchants/apps';
import ActionCtaPreview from '@cohort/merchants/apps/common/ActionCtaPreview';
import type {FacebookTagInPostTriggerStruct} from '@cohort/shared/apps/facebook/triggers/tagInPost';
import React from 'react';
import {useTranslation} from 'react-i18next';

const FacebookTagInPostTriggerActionCtaComponentPreview: React.FC<
  PreviewCtaComponentProps<FacebookTagInPostTriggerStruct>
> = ({localizationConfig}) => {
  const {t} = useTranslation('app-facebook', {
    keyPrefix: 'triggers.tag-in-post',
    lng: localizationConfig.desiredLanguage,
  });
  return <ActionCtaPreview text={t('ctaTitle')} />;
};

export default FacebookTagInPostTriggerActionCtaComponentPreview;
